"use client";

import { useTranslations } from "@/i18n/client";
import { useMemo } from "react";

export const Translate = ({
	children,
	params,
	parseHTML = false,
}: {
	children: string;
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	params?: Record<string, any>;
	parseHTML?: boolean | keyof React.JSX.IntrinsicElements;
}): string | React.JSX.Element => {
	const t = useTranslations();

	const result = t(children, params);

	const replaceChildren = useMemo(() => {
		if (!params) {
			return result;
		}
		return result.replace(/{{(.*?)}}/g, (_, key) => {
			return params?.[key] || "";
		});
	}, [result, params]);

	if (parseHTML) {
		const Component = typeof parseHTML === "boolean" ? "span" : parseHTML;
		// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
		return <Component dangerouslySetInnerHTML={{ __html: replaceChildren }} />;
	}

	return replaceChildren;
};

export const T = Translate;
